<template>
  <div>
    <ReportTable
      v-if="reportReady"
      :fields="fields"
      :groupBy="groupBy"
      :summaryFields="summaryFields"
      :data="data"
      :headerData="headerData"
      :reportHeader="reportHeader"
      :summaryOnly="summaryOnly"
      :reportTitle="reportTitle"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
//
export default {
  name: "Report",
  components: {
    ReportTable: () => import("../components/ReportTable.vue"),
    // VRuntimeTemplate,
  },
  props: {},
  data() {
    return {
      reportReady: false,
      reportTitle: "",
      fields: [],
      summaryFields: {},
      groupBy: [],
      reportHeader: "",
      headerData: null,
      summaryOnly: false,
      data: [],
    };
  },
  mounted() {
    var that = this;
    var dataObject = {
      object_name: "reports",
      // all_records: true,
      qry: { _id: this.$route.params.id },
    };
    axios
      .post(this.serverURL + "/get_data", dataObject, {
        withCredentials: true,
      })
      .then((response) => {
        var data = response.data.model[0];
        that.reportTitle = data.report_name;
        that.reportHeader = data.report_header;
        data.selected_report_fields = JSON.parse(data.selected_report_fields);
        that.summaryOnly = data.summary_only;
        Object.keys(data.selected_report_fields).forEach((f) => {
          that.fields.push(f);
          if (
            data.selected_report_fields[f].summary &&
            data.selected_report_fields[f].summary.includes("groupBy")
          ) {
            that.groupBy.push(f);
          }
          if (
            data.selected_report_fields[f].summary &&
            data.selected_report_fields[f].summary.length
          ) {
            that.summaryFields[f] = {};
            data.selected_report_fields[f].summary.forEach((s) => {
              that.summaryFields[f][s] = true;
            });
          }
        });
        var qry = {};
        var proj = {};
        this.fields.forEach((f) => {
          qry[f] = { $exists: true };
          proj[f] = 1;
        });
        var dateQry = JSON.parse(localStorage.getItem("reportDatesQry"));
        // qry = {
        //   ...qry,
        //   ...dateQry,
        // };
        var dateField = "converted_date";
        var dates = dateQry.dates;
        var match = qry;

        match["converted_date"] = {
          $gte: fun.formatDate(dates[0], true, null, true),
          $lt: fun.formatDate(dates[1], true, null, true),
        };
        var pipeline = [
          {
            $addFields: {
              converted_date: {
                $ifNull: [
                  {
                    $dateFromString: {
                      dateString: "$" + dateQry.dateField,
                      onError: null,
                    },
                  },
                  {
                    $dateFromString: {
                      dateString: "1/1/1800 00:00",
                    },
                  },
                ],
              },
            },
          },
          {
            $match: match,
          },
          // {
          //   $project: proj,
          // },
        ];
        dataObject = {
          object_name: data.parent,
          all_records: true,
          // fields: this.fields,
          pipeline_date_fields: [dateField],
          pipeline: pipeline,
          qry: qry,
        };
        axios
          .post(this.serverURL + "/get_data", dataObject, {
            withCredentials: true,
          })
          .then((response) => {
            this.data = response.data.model;
            this.headerData = this.data[0];
            this.reportReady = true;
          });
      })
      .catch((r) => {
        console.log(r);
        // this.$root.logout();
      });
  },
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="css" scoped></style>
